import type { INBPTThresholdFilters } from '@/types/eos/filters'
import type { INBPTForm } from '@/types/eos/forms'
import type { INBPTThreshold } from '@/types/eos/Thresholds'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export const createNBPTThreshold = async (form: INBPTForm) => {
  const result = await axios.post(import.meta.env.VITE_APP_NBPT_ENDPOINT, form)
  return result.data
}

export const getNBPTThresholds = async (filters: INBPTThresholdFilters): Promise<IPage<INBPTThreshold>> => {
  const result = await axios.get(import.meta.env.VITE_APP_NBPT_ENDPOINT, { params: filters })
  return result.data
}

export const deleteNBPTThreshold = async (id: number) => {
  const params = {
    id,
  }

  await axios.delete(import.meta.env.VITE_APP_NBPT_ENDPOINT, { data: params })
}
